import { Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Models } from '$models';
import { BehaviorSubject, combineLatest, map } from 'rxjs';

const FIRST_LOOK_DESCRIPTION = 'Online - First Look';
const FIRST_LOOK_COLOR = '#1565C0';

@Component({
  selector: 'app-auction-type-indicator',
  templateUrl: './auction-type-indicator.component.html',
  styleUrls: ['./auction-type-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuctionTypeIndicatorComponent implements OnInit, OnChanges {
  @Input() categoryType?: Models.PropertyCategoryType = 0;
  @Input() programRecordType?: string;
  @Input() cycle?: number;

  public categoryType$ = new BehaviorSubject(0);
  private isFirstLook$ = new BehaviorSubject(false);

  public description$ = combineLatest([this.categoryType$, this.isFirstLook$]).pipe(
    map(([cat, isFirstLook]) => isFirstLook ? FIRST_LOOK_DESCRIPTION : Models.AUCTION_TYPE_DESCRIPTION_BY_CAT[String(cat)]),
  );

  public color$ = combineLatest([this.categoryType$, this.isFirstLook$]).pipe(
    map(([cat, isFirstLook]) => isFirstLook ? FIRST_LOOK_COLOR : Models.AUCTION_TYPE_COLOR_BY_CAT[String(cat)]),
    map(color => (color ? color : '#00796B')),
  );

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['categoryType'] && this.categoryType) {
      this.categoryType$.next(this.categoryType || 0);
    }

    if (changes['programRecordType'] || changes['cycle']) {
      this.isFirstLook$.next(this.programRecordType === Models.ProgramRecordType.DAY_1 && this.cycle === Models.FIRST_LOOK_CYCLE);
    }
  }
}
